import { useState, useRef, type MutableRefObject } from "react"
import DateRangePickerNavBar from "./DateRangePickerNavBar"
import DateRangePickerGrid from "./DateRangePickerGrid"

type DateRangePickerBodyProps = {
  scrollToMonthRef: MutableRefObject<((date: Date) => void) | null>
  initialStart?: string
}

function DateRangePickerBody(props: DateRangePickerBodyProps) {
  const { scrollToMonthRef, initialStart } = props

  const [focusMonth, setFocusMonth] = useState<Date>(() =>
    initialStart ? new Date(initialStart) : new Date(),
  )

  const setNavMonthRef = useRef<(month: Date) => void>(() => {})

  function navigateToMonth(month: Date) {
    setFocusMonth(month)
    setNavMonthRef.current(month)
  }

  scrollToMonthRef.current = navigateToMonth

  return (
    <>
      <DateRangePickerNavBar
        initialMonth={focusMonth}
        setNavMonthRef={setNavMonthRef}
        onNavigate={navigateToMonth}
      />
      <div className="ui-date-picker-body">
        <DateRangePickerGrid
          focusMonth={focusMonth}
          setNavMonthRef={setNavMonthRef}
        />
      </div>
    </>
  )
}

export default DateRangePickerBody
